import React, { useEffect, useState } from 'react'
import LopBanDoApi from '../../api/LopBanDoApi';
import ol from "openlayers";
import "ol/ol.css";
import { SelectHuyen } from '../../shared/selecthuyen/SelectHuyen';
import ThongBao from '../../core/ThongBao';
import HienTrangSuDungDatLuaApi from '../../api/HienTrangSuDungDatLuaApi';
import { ModalDiemLayMau } from './ModalDiemLayMau';
import Authen from '../../core/Authen';

export const DiemLayMau = () => {
    const view = new ol.View({
        center: [11725287.264889468, 2355407.026607706],
        zoom: 11
    });

    const kieuBanDo = 6;
    var [map, setMap] = useState(new ol.Map());
    // var map;
    const [listLopBanDos, setLopBanDo] = useState([]);
    var [thongTin, setThongTin] = useState({});
    const [filter, setFilter] = useState();
    var [provinceDat, setDat] = useState(new ol.layer.Vector());
    var [sourceDat, setSourcDat] = useState(new ol.source.Vector());
    var [selectDat, setSelectDat] = useState(null);
    const [flagAddEdit, setFlagAddEdit] = useState(0);
    const [draw, setdraw] = useState(null);
    const [IdHuyen, setIdHuyen] = useState(0);
    const [flagEdit, setFlagEdit] = useState(false);
    const [flagDelete, setFlagDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [isThemMoi, setThemMoi] = useState(true);

    const [roleAdd,setRoleAdd] = useState(false);
    const [roleEdit,setRoleEdit] = useState(false);

    const style = (text) => {
        if(text != null && text.substring(0,4) == "C.CP"){
            return new ol.style.Style({
                image: new ol.style.Circle({
                    radius: 5,
                    fill: new ol.style.Fill({
                        color: "#00ff00",
                    }),
                }),
                text: new ol.style.Text({
                    text: text,
                    offsetY: -12,
                    fill: new ol.style.Fill({
                        color: "#040482"
                    })
                })
            });
        }
        return new ol.style.Style({
            image: new ol.style.Circle({
                radius: 4,
                fill: new ol.style.Fill({
                    color: "#0000ff",
                }),
            }),
            text: new ol.style.Text({
                text: text,
                offsetY: -12,
                fill: new ol.style.Fill({
                    color: "#040482"
                })
            })
        });
    }

    const stylefunction = function (feature, resolution) {
        let text = '';
        if (resolution < 10) {
            text = feature.get('tenpd');
        }
        return style(text);
    }

    const highlightStyle = new ol.style.Style({
        image: new ol.style.Circle({
            radius: 4,
            fill: new ol.style.Fill({
                color: "rgb(37 98 236)",
            }),
        })
    });

    const clickEdit = () => {
        if (flagAddEdit === 2) {
            setFlagAddEdit(0);
            map.getInteractions().forEach(item => {
                map.removeInteraction(item);
            })
        }
        else {
            setFlagAddEdit(2);
            let select = new ol.interaction.Select({ wrapX: false, });
            let modify = new ol.interaction.Modify({ features: select.getFeatures(), });
            map.getInteractions().extend([select, modify]);
            var selected_features = select.getFeatures();
            var dirty = {};
            selected_features.on('add', function (evt) {
                var feature = evt.element;
                var fid = feature.getId();
                feature.on('change', function (evt) {
                    dirty[fid] = true;
                });
            });

            selected_features.on('remove', function (evt) {
                var feature = evt.element;
                var fid = feature.getId();
                if (dirty[fid]) {
                    ThongBao.printConfirmationDialog("Bạn có muốn cập nhật sử thay đổi này không?", () => {
                        var geoJson = new ol.format.WKT();
                        var geoText = geoJson.writeGeometry(feature.getGeometry());
                        thongTin.Geometry = geoText;
                        setThongTin(thongTin);
                        setThemMoi(false);
                        setShowEdit(true);
                    }, () => {
                        provinceDat.getSource().clear();
                    });
                }
            });


            setMap(map);
        }
    }

    const clickAdd = () => {
        if (flagAddEdit === 0) {
            setFlagAddEdit(1);
            if (selectDat !== null) {
                selectDat.setStyle(stylefunction);
                setSelectDat(selectDat);
                thongTin = {};
                setThongTin(thongTin);
            }
            map.addInteraction(draw);
        }
        else {
            map.removeInteraction(draw);
            setFlagAddEdit(0);
        }
        setMap(map);
    }

    const loadLopBanDo = async (idhuyen) => {
        let params = {
            kieuBanDo: kieuBanDo,
            idHuyen: idhuyen
        }

        const list = await LopBanDoApi.getLopBanDo(params);
        list.forEach(item => {
            if (item.Type === 1) {
                let province = new ol.layer.Image({
                    source: new ol.source.ImageWMS({
                        url: item.Url,
                        params: { layers: item.LayerName, version: item.Version },
                        serverType: "geoserver",
                        ratio: item.Ratio,
                    })
                });
                if (item.Checked) {
                    province.setVisible(item.Checked);
                }
                map.addLayer(province);
                item.province = province;
            }
            else if (item.Type === kieuBanDo) {
                sourceDat = new ol.source.Vector({
                    format: new ol.format.GeoJSON(),
                    url: item.Url
                })
                provinceDat = new ol.layer.Vector({
                    source: sourceDat,
                    style: stylefunction
                })

                function addInteractions() {
                    var flagHtml = document.getElementById('btnAdd').getAttribute('flagadd');
                    var drawNew = new ol.interaction.Draw({
                        source: sourceDat,
                        type: "Point",
                        style: new ol.style.Style({
                            image: new ol.style.Circle({
                                radius: 4,
                                fill: new ol.style.Fill({
                                    color: "rgb(37 98 236)",
                                }),
                            })
                        })
                    });
                    setdraw(drawNew);
                    if (flagHtml === "1") {
                        map.addInteraction(drawNew);
                    }
                }
                if (item.Checked) {
                    provinceDat.setVisible(item.Checked);
                }
                map.addLayer(provinceDat);
                item.province = provinceDat;
                setDat(provinceDat);
                setSourcDat(sourceDat);
                addInteractions();
                provinceDat.getSource().on('addfeature', function (event) {
                    var ev = document.getElementById('btnAdd');
                    var flagHtml = 0;
                    if (ev != null) {
                        flagHtml = ev.getAttribute('flagadd');
                    }
                    if (flagHtml === "1" && event.feature.getId() == null) {
                        ThongBao.printConfirmationDialog("Bạn có muốn thêm khoảng đất này không?", () => {
                            var feature = event.feature;
                            var geoJson = new ol.format.WKT();
                            var geoText = geoJson.writeGeometry(feature.getGeometry());
                            thongTin.Geometry = geoText;
                            thongTin.gid = provinceDat.getSource().getFeatures()[0].getId();
                            setThongTin(thongTin);
                            setThemMoi(true);
                            setShowEdit(true);
                        }, () => {
                            provinceDat.getSource().removeFeature(event.feature);
                        });
                    }
                })
            }

        });
        setLopBanDo(list);
        setMap(map);
    }
    useEffect(() => {
        
        setRoleAdd(Authen.checkQuyen("DIEMLAYMAUDAT_CREATE"));
        setRoleEdit(Authen.checkQuyen("DIEMLAYMAUDAT_UPDATE"));
        setFlagDelete(Authen.checkQuyen("DIEMLAYMAUDAT_DELETE"));
        map = new ol.Map({
            target: "map",
            controls: new ol.control.defaults().extend([
                new ol.control.ScaleLine({
                    units: 'metric'
                }),
                new ol.control.FullScreen(),
                new ol.control.ZoomSlider()
            ]),
            layers: [],
            view: view
        });

        map.on('click', function (evt) {
            setFlagEdit(false);
            var flagHtml = document.getElementById('btnEdit').getAttribute('flagedit');
            if (flagHtml === "1") {
                if (selectDat !== null) {
                    selectDat = null;
                    setSelectDat(selectDat);
                }
                return;
            }

            if (selectDat !== null && flagHtml !== "2") {
                selectDat.setStyle(stylefunction);
                setSelectDat(selectDat);
                thongTin = {};
                setThongTin(thongTin);
            }
            map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                console.log(feature)
                feature.setStyle(highlightStyle);
                if (feature != null) {
                    thongTin.gid = feature.getId();
                    thongTin.cat = feature.get('cat');
                    thongTin.cec = feature.get('cec');
                    thongTin.dungtrong = feature.get('dungtrong');
                    thongTin.id3 = feature.get('id3');
                    thongTin.k2o = feature.get('k2o');
                    thongTin.mau_anhhuo = feature.get('mau_anhhuo');
                    thongTin.n = feature.get('n');
                    thongTin.oc = feature.get('oc');
                    thongTin.cec = feature.get('cec');
                    thongTin.om = feature.get('om');
                    thongTin.p2o5 = feature.get('p2o5');
                    thongTin.phkcl = feature.get('phkcl');
                    thongTin.set = feature.get('set');
                    thongTin.tenpd = feature.get('tenpd');
                    thongTin.thit = feature.get('thit');
                    setThongTin(thongTin);
                    selectDat = feature;
                    setSelectDat(selectDat);
                    setFlagEdit(true);
                }
                else {
                    if (flagHtml !== "2") {
                        thongTin = {};
                        setThongTin(thongTin);
                    }
                }
            });
        });
        // setMap(map);

    }, []);

    const getIdHuyen = (event) => {
        if (event.value !== 0 && event.value !== IdHuyen) {
            listLopBanDos.forEach(item => {
                map.removeLayer(item.province);
            })
            setIdHuyen(event.value)
            map.setView(new ol.View({
                center: [event.toaDoX, event.toaDoY],
                zoom: event.zoom
            }));
            loadLopBanDo(event.value);
        }
    }

    const checkBoHandler = () => { };

    const clickRow = (id) => {
        listLopBanDos.forEach(item => {
            if (item.Id === id) {
                item.Checked = !item.Checked;
                map.getLayers().forEach(l => {
                    if (l === item.province) {
                        l.setVisible(item.Checked);
                    }
                })
            }
        });
        setLopBanDo([...listLopBanDos]);
        setDat(map);
    }

    const timKiem = () => {

    }

    function onChangeFilter(e) {
        setFilter(e.target.value)
    }

    const delFeature = () => {
        ThongBao.printConfirmationDialog("Bạn có muốn xóa khoảng đất đã chọn đi không?", () => {
            HienTrangSuDungDatLuaApi.delete(thongTin.gid).then(() => {
                provinceDat.getSource().removeFeature(selectDat);
                ThongBao.printSuccessMessage("Xóa khoảnh đất thành công!");
            });
        });
    }

    const clickEditThongTin = () => {
        // console.log(thongTin);
        setShowEdit(true);
        setThemMoi(false);

    }

    const closeThongTin = () => {
        setShowEdit(false);
    }

    const saveSuccess = () => {
        setShowEdit(false);
        provinceDat.getSource().clear();
    }

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h5 className="m-0 text-primary">Điểm lấy mẫu đất</h5>
                </div>
                <div className="col-md-4">
                    <SelectHuyen onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyen>
                </div>
                {/* <div className="input-group col-md-3">
                    <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                    <div className="input-group-append">
                        <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                    </div>
                </div> */}
                <div className="col-md-4 bd-button text-right">
                    <button id="btnEditThongTin" type="button" className="btn btn-primary btn-sm" disabled={!flagEdit} onClick={clickEditThongTin}><i className='far fa-edit'></i> Sửa TT </button>
                    {roleAdd ===true? (<button id="btnAdd" disabled={flagAddEdit === 2} type="button" className="btn btn-success btn-sm" onClick={clickAdd} flagadd={flagAddEdit}><i className='fas fa-plus' hidden={flagAddEdit === 1 ? true : false}></i> {flagAddEdit === 1 ? 'Đóng' : 'Thêm'}</button>):''}
                    {roleEdit === true? (<button id="btnEdit" disabled={flagAddEdit === 1} type="button" className="btn btn-primary btn-sm" onClick={clickEdit} flagedit={flagAddEdit}><i className='fas fa-edit' hidden={flagAddEdit === 2 ? true : false}></i> {flagAddEdit === 2 ? 'Đóng' : 'Sửa'}</button>):''}
                    {flagDelete === true?(<button type="button" disabled={flagAddEdit !== 0} className="btn btn-danger btn-sm" onClick={delFeature}><i className='fas fa-trash-alt'></i></button>):''}
                    
                </div>
            </div>
            <div className="card-body">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-9 ban-do" id="map">

                        </div>
                        <div className="col-md-3 list-lop">
                            <div className="row lop-ban-do">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th className="col-checkbox"></th>
                                            <th>Lớp bản đồ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listLopBanDos.map((item, key) => {
                                                return (
                                                    <tr onClick={() => clickRow(item.Id)} key={key}>
                                                        <td className="col-checkbox">
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={checkBoHandler} />
                                                            </div>
                                                        </td>
                                                        <td>{item.Name}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="row thong-tin">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th className="col-name">Tên</th>
                                            <th>Thông tin</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="col-name">cat</td>
                                            <td>{thongTin.cat}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">cec</td>
                                            <td>{thongTin.cec}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">dungtrong</td>
                                            <td>{thongTin.dungtrong}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">id3</td>
                                            <td>{thongTin.id3}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">k2o</td>
                                            <td>{thongTin.k2o}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">mau_anhhuo</td>
                                            <td>{thongTin.mau_anhhuo}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">n</td>
                                            <td>{thongTin.n}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">oc</td>
                                            <td>{thongTin.oc}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">om</td>
                                            <td>{thongTin.om}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">p2o5</td>
                                            <td>{thongTin.p2o5}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">phkcl</td>
                                            <td>{thongTin.phkcl}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">set</td>
                                            <td>{thongTin.set}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">tenpd</td>
                                            <td>{thongTin.tenpd}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">thit</td>
                                            <td>{thongTin.thit}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalDiemLayMau showEdit={showEdit} handleClose={closeThongTin} thongTin={thongTin} themMoi={isThemMoi} saveSuccess={saveSuccess}></ModalDiemLayMau>
        </div>
    )
}
